import { FC } from "react"
import classes from "./styles.module.scss"
import { Flex, Paper, Stack, Text } from "@mantine/core"

interface CardProps {
	title?: string | React.ReactNode
	info?: React.ReactNode
	description?: React.ReactNode
	action?: React.ReactNode
	variant?: "light" | "gray" | "dark"
	size?: "md" | "lg"
	flex?: number
}

interface CardStyles {
	bg?: string
	titleColor?: string
	infoColor?: string
	descriptionColor?: string
}

export const Card: FC<CardProps> = ({
	title,
	info,
	description,
	action,
	variant = "light",
	size = "md",
	flex = 1,
}) => {
	const cardStyles: CardStyles = {}

	if (variant === "light") {
		cardStyles.bg = "#fff"
		cardStyles.titleColor = "#000"
		cardStyles.infoColor = "#000"
		cardStyles.descriptionColor = "#636363"
	} else if (variant === "gray") {
		cardStyles.bg = "#F0F0F0"
		cardStyles.titleColor = "rgba(0, 0, 0, 0.70)"
		cardStyles.infoColor = "#000"
		cardStyles.descriptionColor = "#636363"
	} else if (variant === "dark") {
		cardStyles.bg = "#000"
		cardStyles.titleColor = "rgba(255, 255, 255, 0.70)"
		cardStyles.infoColor = "#FFF"
		cardStyles.descriptionColor = "rgba(255, 255, 255, 0.70)"
	}

	return (
		<Paper flex={flex} className={classes.card} radius={10} bg={cardStyles.bg} miw={304}>
			<Stack className={classes.container} justify="space-between" gap={107} h="100%">
				{title && size === "lg" ? (
					<Text c={cardStyles.titleColor} fz={32} fw={600} lh={1.1}>
						{title}
					</Text>
				) : (
					<Text
						c={cardStyles.titleColor}
						className={classes.title_small}
						fz={20}
						fw={600}
						lh={1.45}
					>
						{title}
					</Text>
				)}
				<Flex justify="space-between" className={classes.content} wrap="wrap" gap={12}>
					<Stack gap={10} flex={2}>
						{info && (
							<div className={classes.info} style={{ color: cardStyles.infoColor }}>
								{info}
							</div>
						)}
						{description && (
							<div className={classes.description} style={{ color: cardStyles.descriptionColor }}>
								{description}
							</div>
						)}
					</Stack>
					{action && action}
				</Flex>
			</Stack>
		</Paper>
	)
}
